// Field service (PRD 88 onwards) shipped dark until milestone M1 was reachable
// (contract ruling R4: PRD 88, PRD 89, PRD 90, PRD 91 Waves 1–2, PRD 95's M1
// waves and PRD 100 Wave 1). While false, the sidebar's Field service group drew
// only for a business holding the module — design partners on an admin grant.
//
// Released in ONE pair of PRs with the api's `released: true`, which also made
// the marketplace's Coming soon card a module card. Since then a business that
// never held it sees the Overview, whose page offers the module
// (fieldServiceNavAccess).
//
// Kept as a constant rather than deleted so a rollback is a one-line PR (the
// COMBINED_REPORTING_LIVE precedent). The web must not merge before the api's
// release is on prod: until then the api still refuses the purchase.
export const FIELD_SERVICE_RELEASED = true;
